// extracted by mini-css-extract-plugin
export default {"container":"burger-ingredient-card_container__8+uoo","price":"burger-ingredient-card_price__KOgXe"};